import produce from 'immer'
import { assign } from 'lodash'

import { areSameValue } from '../../../core/utils'

import {
  ASSIGN_BRAND_CURATION_TASK_USER,
  DUPLICATE_BRAND_CURATION_TASK,
  FETCH_BRAND_CURATION_TASK,
  REOPEN_BRAND_CURATION_TASK,
  UPDATE_BRAND_CURATION_TASK,
  UPDATE_BRAND_CURATION_TASK_STATUS_FLAG,
  UPDATE_LOCATION_CUISINE_TYPE_AND_LOCATION_TYPE_SAME_AS_BRAND,
} from '../action-types'
import { BRAND_CURATION_TASK_INITIAL_STATE } from '../initial-states'

const brandCurationTaskReducer = (
  state = BRAND_CURATION_TASK_INITIAL_STATE,
  action,
) => {
  switch (action.type) {
    case FETCH_BRAND_CURATION_TASK.START:
      return produce(state, nextState =>
        assign(nextState, {
          isLoading: true,
          error: undefined,
          data: {},
        }),
      )

    case FETCH_BRAND_CURATION_TASK.COMPLETE:
      return produce(state, nextState => {
        const { brandCurationTask } = action.payload.data

        return assign(nextState, {
          isLoading: false,
          error: undefined,
          data: brandCurationTask,
        })
      })

    case FETCH_BRAND_CURATION_TASK.FAIL:
      return produce(state, nextState =>
        assign(nextState, {
          isLoading: false,
          error: action.error.message,
          data: {},
        }),
      )

    case FETCH_BRAND_CURATION_TASK.CLEANUP:
      return { ...BRAND_CURATION_TASK_INITIAL_STATE }

    case UPDATE_BRAND_CURATION_TASK_STATUS_FLAG.START:
    case REOPEN_BRAND_CURATION_TASK.START:
    case UPDATE_BRAND_CURATION_TASK.START:
      return produce(state, nextState =>
        assign(nextState, {
          isUpdateLoading: true,
          updateError: null,
        }),
      )

    case REOPEN_BRAND_CURATION_TASK.COMPLETE:
      return produce(state, nextState => {
        const { reopenBrandCurationTask: brandCurationTask } =
          action.payload.data

        assign(nextState.data, brandCurationTask)
        assign(nextState, {
          isUpdateLoading: false,
          updateError: null,
        })
      })

    case UPDATE_BRAND_CURATION_TASK.COMPLETE:
      return produce(state, nextState => {
        const { updateBrandCurationTask: brandCurationTask } =
          action.payload.data

        assign(nextState.data, brandCurationTask)
        assign(nextState, {
          isUpdateLoading: false,
          updateError: null,
        })
      })

    case UPDATE_BRAND_CURATION_TASK_STATUS_FLAG.COMPLETE:
      return produce(state, nextState => {
        const { updateBrandCurationTaskStatusFlag: brandCurationTask } =
          action.payload.data

        assign(nextState.data, brandCurationTask)
        assign(nextState, {
          isUpdateLoading: false,
          updateError: null,
        })
      })

    case UPDATE_BRAND_CURATION_TASK_STATUS_FLAG.FAIL:
    case REOPEN_BRAND_CURATION_TASK.FAIL:
    case UPDATE_BRAND_CURATION_TASK.FAIL:
      return produce(state, nextState =>
        assign(nextState, {
          isUpdateLoading: false,
          updateError: action.error.message,
        }),
      )

    case ASSIGN_BRAND_CURATION_TASK_USER.COMPLETE:
      return produce(state, nextState => {
        const { assignUserToBrandCurationTask: brandCurationTask } =
          action.payload.data

        if (areSameValue(brandCurationTask.id, state.data?.id)) {
          assign(nextState.data, brandCurationTask)
        }
      })

    case UPDATE_LOCATION_CUISINE_TYPE_AND_LOCATION_TYPE_SAME_AS_BRAND.START:
      return produce(state, nextState =>
        assign(nextState, {
          updateError: null,
        }),
      )

    case UPDATE_LOCATION_CUISINE_TYPE_AND_LOCATION_TYPE_SAME_AS_BRAND.COMPLETE:
      return produce(state, nextState => {
        const {
          updateLocationCuisineTypeAndLocationTypeSameAsBrand:
            brandCurationTask,
        } = action.payload.data

        assign(nextState.data, brandCurationTask)
        assign(nextState, {
          updateError: null,
        })
      })

    case UPDATE_LOCATION_CUISINE_TYPE_AND_LOCATION_TYPE_SAME_AS_BRAND.FAIL:
      return produce(state, nextState =>
        assign(nextState, {
          updateError: action.error.message,
        }),
      )

    case DUPLICATE_BRAND_CURATION_TASK.START:
      return produce(state, nextState =>
        assign(nextState, {
          isDuplicateLoading: true,
          duplicateError: null,
        }),
      )

    case DUPLICATE_BRAND_CURATION_TASK.COMPLETE:
      return produce(state, nextState => {
        assign(nextState, {
          isDuplicateLoading: false,
          duplicateError: null,
        })
      })

    case DUPLICATE_BRAND_CURATION_TASK.FAIL:
      return produce(state, nextState =>
        assign(nextState, {
          isDuplicateLoading: false,
          duplicateError: action.error.message,
        }),
      )

    default:
      return state
  }
}

export default brandCurationTaskReducer
